import styled from "@emotion/styled";
import { Box, Theme } from "@mui/material";
import DrawerImage from "../../assets/DrawerBackground.webp"

export const  StyledBox = styled(Box)<{theme: Theme}>((props) => ({
    backgroundColor: "white",
    zIndex: 1300,
    display: 'flex',
    justifyContent: "space-between",
    position: "sticky",
    top: 0,
    padding: props.theme.spacing(1)
}));

export const StyledDrawerBox = styled(Box)((props) => ({
    width: '280px',
    height: '100%',
    backgroundImage: `url(${DrawerImage})`,
    backgroundSize: "cover",
    marginLeft: "-5px",
}))